// extracted by mini-css-extract-plugin
export var actionButton = "_dx-0";
export var attachmentLine = "_dx-1";
export var fileInput = "_dx-2";
export var fileUploadWrapper = "_dx-4";
export var footer = "_dx-3";
export var modalContent = "_dx-5";
export var paperclip = "_dx-6";
export var quillEditor = "_dx-7";